import React from "react";

export default function NextIcon() {
  return <div>→</div>;
}
